<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="5">
				<el-select clearable style="width: 100%;" v-model="searchInfo.businessID" filterable placeholder="请选择商家">
				    <el-option v-for="item in businessList" :key="item.entry_business_id" :label="item.entry_business_name" :value="item.entry_business_id"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="7"> 
				<el-input clearable placeholder="请输入档口名称" v-model="searchInfo.stall_name">
					<template slot="prepend">档口名称</template>
				</el-input>
			</el-col>
			<el-col :span="9"> 
				<el-button type="primary" @click="searchStall" icon="el-icon-search">搜索</el-button>
				<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
				<el-button type="primary" icon="el-icon-plus" @click="addStall">新增</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="stallList"  style="width: 100%"  height="700">
			    <el-table-column fixed="left" prop="name" label="档口名称" width="150" align="center"></el-table-column>
			    <el-table-column prop="code" label="档口编码" width="120" align="center"></el-table-column>
			    <el-table-column prop="contactname" label="联系人"  width="120" align="center"></el-table-column>
			    <el-table-column prop="telphone" label="联系电话" width="120" align="center"></el-table-column>
			    <el-table-column prop="business_name" label="所属商家" align="center"></el-table-column>
				<el-table-column prop="address" label="商铺位置" align="center"></el-table-column>
				<el-table-column prop="drawproportion" label="抽成比例" align="center"></el-table-column>
				<el-table-column prop="statename" label="状态" align="center"></el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<a @click="goStallDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-Stall">详情</i>
						</a>
						<a v-show="scope.row.state == 'stop'" @click="ChangeState(scope.$index, scope.row)" title="启用" style="cursor:pointer;margin-left: 10px;color: #E6A23C;">
							<i class="el-icon-bottom">启用</i>
						</a>
						<a v-show="scope.row.state == 'normal'" @click="ChangeState(scope.$index, scope.row)" title="停用" style="cursor:pointer;margin-left: 10px;color: #67C23A;">
							<i class="el-icon-top">停用</i>
						</a>
						<a v-show="scope.row.state == 'stop'" @click="deleteStalls(scope.$index, scope.row)" title="删除档口" style="cursor:pointer;margin-left: 10px;color: #F56C6C;">
							<i class="el-icon-delete">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="stallTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="false" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<StallDetail @needRefrash="needRefrash" :select_id="selectID" :businesses="businessList"></StallDetail>
		</el-dialog>
	</div>
</template>

<script>
	import {queryBusinessLists,queryStallLists,ChangeStallState,deleteStall } from '/static/apiUrl.js'
	import StallDetail from './stalldetail'
	export default {
		name : 'stallList',
		data() {
			return {
				detailShow: false,
				editok : false,
				detailTitle: '档口详情',
				selectID: '',	
				searchInfo:{
					businessID: '',
					stall_name : '',
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				businessList : [],
				stallTotal : 0,
				stallList : [],				
			}
		},
		mounted() {
			this.initData()
			this.queryStall()
		},
		components: {
			StallDetail,
		},
		methods: {
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.queryStall()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.queryStall()
			},
			ChangeState(idx, row){
				console.log(idx, row)
				let name = ""
				let new_state = ""
				if (row.state == "normal") {
					name = "停用"
					new_state = "stop"
				} else { 
					name = "启用"
					new_state = "normal"
				}
				this.$confirm('确定将 ' + row.name + ' ' + name + '?', name, {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					ChangeStallState({
						state: new_state,
						id: row.id
					}).then(res => {
						console.log(res)
						if (0 == res.code) {
							row.statename = name
							row.state = new_state
							this.$message({
								type: 'success',
								message: name + '成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch((err) => {
					console.log(err)
				});
			},
			deleteStalls(idx,row){
				console.log(idx,row)
				this.$confirm('确定将 '+row.name+' 删除?', '档口删除', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let fids = [row.id]
					deleteStall({
						ids : fids
					}).then(res => {
						console.log(res)
						if(0 == res.code){
							this.stallList.splice(idx,1)
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch((err) => {
					console.log(err)
				});
			},
			initData() {
				queryBusinessLists({
					state: "normal",
					offset: 0,
					limit: 100
				}).then(res => {
					console.log(res)
					if (0 == res.code) {
						this.businessList = res.data.data
					}
				})
			},
			searchStall(){
				this.param.page = 1
				this.stallList = []
				this.queryStall()
			},
			clearSearch(){
				this.searchInfo.businessID = ''
				this.searchInfo.stall_name = ''
				this.param.page = 1
				this.queryStall()
			},
			queryStall(){
				this.stallList = []
				queryStallLists({
					business_id : this.searchInfo.businessID,
					name : this.searchInfo.stall_name,
					offset : (this.param.page - 1) * this.param.pagenum,
					limit : this.param.pagenum
				}).then(res => {
					console.log(res)
					if(0 == res.code){
						this.stallTotal = res.data.total
						res.data.data.forEach((stall) => {
							this.stallList.push({
								id : stall.stall_id,
								name : stall.stall_name,
								code : stall.stall_code,
								contactname : stall.stall_contactname,
								telphone : stall.stall_telphone,
								business_name : stall.stall_owenbusiness_name,
								address : stall.stall_address,
								drawproportion : stall.stall_drawproportion,
								state : stall.stall_state,
								statename : stall.stall_state == 'normal' ? '启用' : '停用',								
							})
						})
					}
				})
			},
			goStallDetail(idx,row){
				this.detailTitle = '档口详情'
				console.log(idx,row)
				this.selectID = row.id
				this.detailShow = true
			},
			addStall(){
				this.detailTitle = "新增档口"
				this.selectID = ''
				this.detailShow = true
			},
			needRefrash(val,isshow){
				console.log(val, isshow)
				this.editok = val
				this.detailShow = isshow
			},
			refrashData() {
				console.log('ddd')
				if(this.editok){
					this.queryStall()
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>